import { Box, Pagination, Stack } from '@mui/material';
import { useState } from 'react';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { alpha, lighten, styled } from '@mui/material/styles';
import { useAppStore } from '../../../store/appStore';

// -----------------------------------------
// Stripe styling for DataGrid
const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.columnHeader}`]: {
        backgroundColor: alpha(lighten(theme.palette.primary.main, 0.5), ODD_OPACITY),
        color: '#023A82',
        fontSize: '14px',
        textAlign: 'center',
    },
    [`& .${gridClasses.cell}`]: {
        fontSize: '14px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
    },
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: '#e6eef6',
    },
    [`& .${gridClasses.row}.odd`]: {
        backgroundColor: 'white',
    },
}));

export default function RetailerProductWiseSchemeReportGrid() {
    // Demo data, replace with your actual filteredData from store.
    const { filteredData } = useAppStore();

    const [pageSize] = useState(8); // You can use more dynamic control.
    const [currentPage, setCurrentPage] = useState(1);

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    // Ensure each row has unique ID
    const rowsWithId = Array.isArray(filteredData)
        ? filteredData.map((row, index) => ({
            ...row,
            id: row.id ?? index,
        }))
        : [];

    const displayedRows = rowsWithId.slice(startIndex, endIndex);

    // Dynamic column generation
    const getColumnWidthFromHeader = (header) => {
        const baseCharWidth = 10;
        const padding = 40;
        return Math.min(header.length * baseCharWidth + padding, 300);
    };

    const columns = displayedRows.length
        ? Object.keys(displayedRows[0])
            .filter((field) => field !== 'id')
            .map((field) => ({
                field,
                headerName: field
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/_/g, ' ')
                    .replace(/^./, (str) => str.toUpperCase()),
                width: getColumnWidthFromHeader(field),
                minWidth: 120,
                renderCell: (params) => {
                    const value = params.row[field];

                    let displayValue = '';
                    if (typeof value === 'boolean') {
                        displayValue = value ? 'True' : 'False';
                    } else if (value !== null && value !== undefined) {
                        displayValue = value;
                    }

                    return (
                        <div
                            style={{
                                wordWrap: 'break-word',
                                whiteSpace: 'normal',
                                width: '100%',
                            }}
                        >
                            {displayValue}
                        </div>
                    );
                },
            }))
        : [];


    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, flexGrow: 1 }} >
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, flexGrow: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, flexGrow: 1 }}>
                    <Box sx={{ height: '100%', width: '100%' }}>
                        {displayedRows?.length > 0 && (
                            <StripedDataGrid
                                sx={{
                                    height: '100%',
                                }}
                                rows={displayedRows}
                                columns={columns}
                                pageSize={pageSize}
                                disableSelectionOnClick
                                getRowId={(row) => row.id}
                                getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'}
                                hideFooterPagination                                
                                getRowHeight={() => "auto"}
                            />
                        )}
                    </Box>
                </Box>
               
            </Box>
            {filteredData?.length > 0 && (
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    display='flex'
                    flexWrap='wrap'
                    spacing={2}
                    sx={{ mb: 0, mt: 0 }}
                >
                    <Pagination
                        count={Math.ceil(filteredData.length / pageSize)}
                        variant="outlined"
                        size="small"
                        shape="rounded"
                        page={currentPage}
                        onChange={handlePageChange}
                    />
                </Stack>
            )}
        </Box>

    );
}



